<template>
  <div class="banner-wrapper">
    <div class="description-wrapper" :style="backgroundImage">
      <img class="dolphin-logo-image" :src="dolphinLogo" alt="Dolphin Logo">
      <div class="desc-wrapper">
        <h1 class="discount-title">
          {{ $t('banners.cloudBannerDiscount.title') }}
        </h1>
        <span class="discount-text-sale">
          {{ $t('banners.cloudBannerDiscount.sale') }}
        </span>
        <span class="discount-text-promo">
          {{ $t('banners.cloudBannerDiscount.promoCode') }}
        </span>
      </div>
      <div class="get-discount">
        <button class="get-discount-button" @click="openLink">
          {{ $t('banners.cloudBannerDiscount.getDiscount') }}
        </button>
        <div>
        <span class="get-discount-text" v-html="$t('banners.cloudBannerDiscount.discountAccess')"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import dolphinLogo from '@/assets/logo-white.svg'
  import { EXPERIMENT_GROUP_NAME_A_EN_URL, EXPERIMENT_GROUP_NAME_A_RU_URL } from '@/constants/experiments'

  export default {
    name: 'CloudBannerA',

    data () {
      return {
        dolphinLogo,
      }
    },

    computed: {
      backgroundImage () {
        const ruImage =  `url(${require('@/assets/cloud/red-and-blue-pc-ru.svg')})`
        const enImage = `url(${require('@/assets/cloud/red-and-blue-pc-en.svg')})`

        return {
          backgroundImage: this.$i18n.locale === 'ru' ? ruImage : enImage
        }
      }
    },

    methods: {
      openLink () {
        if (this.$i18n.locale === 'ru') {
          window.open(EXPERIMENT_GROUP_NAME_A_RU_URL, '_blank')
        } else {
          window.open(EXPERIMENT_GROUP_NAME_A_EN_URL, '_blank')
        }
      }
    }
  }
</script>

<style scoped>
  .banner-wrapper {
    background: linear-gradient(180deg, #19AEFF 0%, #0163DF 100%);
    border-radius: 24px;
    width: 100%;
    margin-top: 32px;
    display: flex;
    font-family: Gilroy,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
    height: 243px;
  }

  .description-wrapper {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px 0 24px 24px;
    color: #FFFFFF;
    flex: 1;
    background: no-repeat right;
  }

  .dolphin-logo-image {
    width: 88px;
    height: 24px;
  }

  .discount-title {
    font-weight: 800;
    font-size: 26px;
    line-height: 116%;
    margin-bottom: 8px;
    max-width: 440px;
  }

  .discount-text-sale {
    font-size: 16px;
    font-weight: 700;
    line-height: 116%;
  }
  .discount-text-promo {
    font-size: 16px;
    font-weight: 400;
    line-height: 116%;
  }

  .get-discount {
    display: flex;
    gap: 20px;
    align-items: center;
  }

  .get-discount-button {
    padding: 12px 24px;
    border-radius: 100px;
    background: #E8FF63;
    color: #28334A;
    font-size: 16px;
    font-weight: 600;
    line-height: 112%;
    white-space: nowrap;
  }

  .get-discount-text {
    text-shadow: 0 0 0 rgba(0, 0, 0, 0.20), 0 0 0 rgba(0, 0, 0, 0.14), 0 0 0 rgba(0, 0, 0, 0.12);
    font-size: 13px;
    font-weight: 500;
    line-height: 116%;
    display: block;
  }

  .first-text > span:last-child {
    display: block;
    font-size: 14px;
    font-weight: 600;
    line-height: 112%;
    color:#28334A;
  }

  .second-text > span:last-child {
    display: block;
    font-size: 14px;
    font-weight: 600;
    line-height: 112%;
    color:#28334A
  }
</style>